module.exports = "<md-dialog flex=50> <md-dialog-content> <div class=md-dialog-content layout=row layout-align=\"start center\" layout-wrap style=background:#fff> <md-progress-linear md-mode=indeterminate ng-if=!percentLoad></md-progress-linear> <md-progress-linear md-mode=determinate value={{percentLoad}} ng-if=percentLoad></md-progress-linear> <p style=margin-bottom:0!important;padding-left:10px><span ng-if=percentLoad>{{percentLoad}}% &nbsp;</span>{{infoMsg}}</p> </div> </md-dialog-content> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/views/progress-loader.html
// module id = 462
// module chunks = 462